import { Component, Input, OnInit } from '@angular/core';
import { STUB_FN_NULL, STUB_FN_FALSE } from 'projects/exi-ui/src/lib/utils/stubs';

@Component({
   selector: 'exi-checkbox',
   template: `
      <button  class="button {{ ctx.type }}"
               [class.selected]="ctx.isSelected(value)" 
               (click)="toggle()" 
               [disabled]="ctx.isDisabled(value)" >
         <div class="checkbox" [icons]="iconConf"></div>    
      </button>
  `,
   styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent<D extends object> implements OnInit {
   @Input() public value: D;
   @Input() public ctx: Checkbox<D>;
   public iconConf: string;


   ngOnInit() {
      this.ctx.type = this.ctx.type || 'CHECK';
      this.ctx.select = this.ctx.select || STUB_FN_NULL;
      this.ctx.unselect = this.ctx.unselect || STUB_FN_NULL;
      this.ctx.isDisabled = this.ctx.isDisabled || STUB_FN_FALSE;
      this.iconConf = `CHK:${this.ctx.type}`;
   }

   public toggle() {
      this.ctx.toggle(this.value);
      if (this.ctx.isSelected(this.value)) {
         this.ctx.select(this.value);
      } else {
         this.ctx.unselect(this.value);
      }
   }
}

export interface Checkbox<D> {
   isSelected: (val: D) => boolean;
   toggle: (val: D) => void;
   type?: CheckboxTypes;
   select?: (val: D) => void;
   unselect?: (val: D) => void;
   isDisabled?: (val: D) => boolean;
}

export type CheckboxTypes = 'CHECK' | 'EYE' | 'PIN';


